import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 24 24">
      <path d="M13 5H19V11L13 5Z"/>
      <path d="M15.291 7.29102L16.7052 8.70524L13.1697 12.2408L11.7555 10.8266L15.291 7.29102Z"/>
      <path d="M9.63416 15.7763L8.21994 17.1905L6.80573 15.7763L8.21994 14.3621L9.63416 15.7763Z"/>
      <path d="M10.3413 15.0692L11.7555 13.655L10.3412 12.2408L8.92705 13.655L10.3413 15.0692Z"/>
      <path d="M4.51472 14.8995L4.51473 19.4853L9.10048 19.4853L4.51472 14.8995Z"/>
    </CommonSVGIcon>
  );
}
